const FooterSectionInfoProvider = {
    footerSectionParagraph: "Schweizerische Radio- und Fernsehgesellschaft\nSociété suisse de radiodiffusion et télévision\nSocietà svizzera di radiotelevisione\nSocietad svizra da radio e televisiun",
    languages: ["FR", "DE", "IT", "RM"]
}

export default FooterSectionInfoProvider